<template>
  <div class="text-center pa-4" style="background: #f8fafc none repeat scroll 0 0; padding: 0 !important;">
    <v-card flat  style="box-shadow:none; border-radius:0;padding-inline:12px;     background: #f8fafc;">
      <div style="background: white; border-radius:24px; padding: 24px;text-align:left;" v-if="companyData">
          <h3 class="my-2 text-left">Insights</h3>
          <v-row style="width:100%;    align-items: center; margin:0; border-radius:10px;text-align:left;">
            <v-col cols="3" v-if="companyData && companyData.company_dashboard_dict && companyData.company_dashboard_dict.chat_response_stats">
              <div style="padding: 24px;border: 1px solid #e6e6e6;border-radius: 24px;     height: 220px;">
                <p class="mb-0 cardTitle">Engagement score</p>
                <div class="mt-6">
                  <h3 class="mainStats" style=""><span class="mainStats">{{companyData.company_dashboard_dict.engagement_score}}</span>/5</h3>
                </div>
              </div>
            </v-col>
            <v-col cols="3" v-if="companyData && companyData.company_dashboard_dict && companyData.company_dashboard_dict.chat_response_stats">
              <div style="padding: 24px;border: 1px solid #e6e6e6;border-radius: 24px;    height: 220px;">
                <p class="mb-0 cardTitle">Employee reachout</p>
                <div class="mt-6">
                  <h3 class="mainStats" style=""><span class="mainStats">{{companyData.company_dashboard_dict.company_employee_reach_stats.employee_reach_percent}}</span> %</h3>
                </div>
                <div style="display: flex;justify-content: space-between;text-align: center; margin-top: 30px;">
                  <p class="mb-0">
                    <span style="font-size: 18px;font-weight: 600;">{{companyData.company_dashboard_dict.company_employee_reach_stats.total_employees}}</span><br>
                    <span style="color: rgb(135, 138, 153);font-size: 14px;font-weight: 400;">Total</span>
                  </p>
                  <p class="mb-0">
                    <span style="font-size: 18px;font-weight: 600;">{{companyData.company_dashboard_dict.company_employee_reach_stats.employee_reach}}</span><br>
                    <span style="color: rgb(135, 138, 153);font-size: 14px;font-weight: 400;">Reachout</span>
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="3" v-if="companyData && companyData.company_dashboard_dict && companyData.company_dashboard_dict.chat_response_stats">
              <div style="padding: 24px;border: 1px solid #e6e6e6;border-radius: 24px;    height: 220px;">
                <p class="mb-0 cardTitle">Disengaged stats</p>
                <div class="mt-6">
                  <h3 class="mainStats" style=""><span class="mainStats">{{companyData.company_dashboard_dict.disengaged_employees_stats.disengaged_employees}}</span></h3>
                </div>
                <div style="display: flex;justify-content: space-between;text-align: center;margin-top: 30px;">
                  <p class="mb-0">
                    <span style="font-size: 18px;font-weight: 600;">{{companyData.company_dashboard_dict.disengaged_employees_stats.disengaged_cases_open}}</span><br>
                    <span style="color: rgb(135, 138, 153);font-size: 14px;font-weight: 400;">Open</span>
                  </p>
                  <p class="mb-0">
                    <span style="font-size: 18px;font-weight: 600;">{{companyData.company_dashboard_dict.disengaged_employees_stats.disengaged_cases_resolved}}</span><br>
                    <span style="color: rgb(135, 138, 153);font-size: 14px;font-weight: 400;">Resolved</span>
                  </p>
                  <p class="mb-0">
                    <span style="font-size: 18px;font-weight: 600;">{{companyData.company_dashboard_dict.disengaged_employees_stats.disengaged_cases_resolution_deadlock}}</span><br>
                    <span style="color: rgb(135, 138, 153);font-size: 14px;font-weight: 400;">Deadlock</span>
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="3" v-if="companyData && companyData.company_dashboard_dict && companyData.company_dashboard_dict.chat_response_stats">
              <div style="padding: 24px;border: 1px solid #e6e6e6;border-radius: 24px;    height: 220px;">
                <p class="mb-0 cardTitle">Fence-sitters stats</p>
                <div class="mt-6">
                  <h3 class="mainStats" style=""><span class="mainStats">{{companyData.company_dashboard_dict.fence_sitters_employees_stats.fence_sitters_employees}}</span></h3>
                </div>
                <div style="display: flex;justify-content: space-between;text-align: center;margin-top: 30px;">
                  <p class="mb-0">
                    <span style="font-size: 18px;font-weight: 600;">{{companyData.company_dashboard_dict.fence_sitters_employees_stats.fence_sitters_cases_open}}</span><br>
                    <span style="color: rgb(135, 138, 153);font-size: 14px;font-weight: 400;">Open</span>
                  </p>
                  <p class="mb-0">
                    <span style="font-size: 18px;font-weight: 600;">{{companyData.company_dashboard_dict.fence_sitters_employees_stats.fence_sitters_cases_resolved}}</span><br>
                    <span style="color: rgb(135, 138, 153);font-size: 14px;font-weight: 400;">Resolved</span>
                  </p>
                  <p class="mb-0">
                    <span style="font-size: 18px;font-weight: 600;">{{companyData.company_dashboard_dict.fence_sitters_employees_stats.fence_sitters_cases_resolution_deadlock}}</span><br>
                    <span style="color: rgb(135, 138, 153);font-size: 14px;font-weight: 400;">Deadlock</span>
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
        <div style="background: white; border-radius:24px; padding: 24px;text-align:left;margin-top:24px;" v-if="companyData">
          <h3 class="my-2 text-left">Employee participation stats</h3>
          <v-row style="width:100%;    align-items: center; margin:0; border-radius:10px;text-align:left;">
            <v-col>
              <div style="padding: 24px;border: 1px solid #e6e6e6; border-radius: 24px;">
              <p class="cardTitle mb-0">Chat response rate</p>
              <div class="mt-6">
              <h3 class="mainStats" v-if="companyData.company_dashboard_dict.user_participation_stats.chat_response_rate">{{companyData.company_dashboard_dict.user_participation_stats.chat_response_rate}}%</h3>
              <h3 style="color: rgb(77, 87, 93); font-size: 25px; margin: 5px 0px 0px; font-weight: 300;padding-top:1px;padding-bottom:1px;" v-else>--</h3>
              </div>
              </div>
            </v-col>
            <v-col v-if="companyData && companyData.company_dashboard_dict && companyData.company_dashboard_dict.user_participation_stats">
            <div style="padding: 24px;border: 1px solid #e6e6e6; border-radius: 24px;">
            <p class="cardTitle mb-0">Total chats</p>
            <div class="mt-6">
            <h3 class="mainStats" style="">{{companyData.company_dashboard_dict.user_participation_stats.total}}</h3>
            </div>
          </div>
            </v-col>
            <v-col v-if="companyData && companyData.company_dashboard_dict && companyData.company_dashboard_dict.user_participation_stats">
              <div style="padding: 24px;border: 1px solid #e6e6e6; border-radius: 24px;">
              <p class="cardTitle mb-0">Initiated</p>
              <div class="mt-6">
              <h3 class="mainStats" v-if="companyData.company_dashboard_dict.user_participation_stats.initiated">{{companyData.company_dashboard_dict.user_participation_stats.initiated}}</h3>
              <h3 style="color: rgb(77, 87, 93); font-size: 25px; margin: 5px 0px 0px; font-weight: 300;padding-top:1px;padding-bottom:1px;" v-else>--</h3>
              </div>
            </div>
            </v-col>
             <v-col v-if="companyData && companyData.company_dashboard_dict && companyData.company_dashboard_dict.user_participation_stats">
               <div style="padding: 24px;border: 1px solid #e6e6e6; border-radius: 24px;">
              <p class="cardTitle mb-0">Inprogress</p>
               <div class="mt-6">
              <h3 class="mainStats" v-if="companyData.company_dashboard_dict.user_participation_stats.inProgress">{{companyData.company_dashboard_dict.user_participation_stats.inProgress}}</h3>
              <h3 style="color: rgb(77, 87, 93); font-size: 25px; margin: 5px 0px 0px; font-weight: 300;padding-top:1px;padding-bottom:1px;" v-else>--</h3>
               </div>
            </div>
            </v-col>
            <v-col>
              <div style="padding: 24px;border: 1px solid #e6e6e6; border-radius: 24px;">
              <p class="cardTitle mb-0">Completed</p>
              <div class="mt-6">
              <h3 class="mainStats" v-if="companyData.company_dashboard_dict.user_participation_stats.completed">{{companyData.company_dashboard_dict.user_participation_stats.completed}}</h3>
              <h3 style="color: rgb(77, 87, 93); font-size: 25px; margin: 5px 0px 0px; font-weight: 300;padding-top:1px;padding-bottom:1px;" v-else>--</h3>
              </div>
              </div>
            </v-col>
          </v-row>
        </div>
      <div style="background: white; border-radius:24px; padding: 24px;text-align:left;margin-top:24px;" v-if="companyData">
          <h3 class="my-2 text-left">Chat response stats</h3>
          <v-row style="width:100%;align-items: center; margin:0; border-radius:10px;text-align:left;">
            <v-col>
              <div style="padding: 24px;border: 1px solid #e6e6e6; border-radius: 24px;">
              <p class="cardTitle mb-0">Chat response rate</p>
              <div class="mt-6">
              <h3 class="mainStats" v-if="companyData.company_dashboard_dict.chat_response_stats.chat_response_rate">{{companyData.company_dashboard_dict.chat_response_stats.chat_response_rate}}%</h3>
              <h3 style="color: rgb(77, 87, 93); font-size: 25px; margin: 5px 0px 0px; font-weight: 300;padding-top:1px;padding-bottom:1px;" v-else>--</h3>
              </div>
              </div>
            </v-col>
            <v-col v-if="companyData && companyData.company_dashboard_dict && companyData.company_dashboard_dict.chat_response_stats">
            
            <div style="padding: 24px;border: 1px solid #e6e6e6; border-radius: 24px;">
              <p class="cardTitle mb-0">Total chats</p>
            <div class="mt-6">
            <h3 class="mainStats" style="">{{companyData.company_dashboard_dict.chat_response_stats.total}}</h3>
          </div>
          </div>
            </v-col>
            <v-col v-if="companyData && companyData.company_dashboard_dict && companyData.company_dashboard_dict.chat_response_stats">
              <div style="padding: 24px;border: 1px solid #e6e6e6; border-radius: 24px;">
              <p class="cardTitle mb-0">Initiated</p>
              <div class="mt-6">
              <h3 class="mainStats" v-if="companyData.company_dashboard_dict.chat_response_stats.initiated">{{companyData.company_dashboard_dict.chat_response_stats.initiated}}</h3>
              <h3 style="color: rgb(77, 87, 93); font-size: 25px; margin: 5px 0px 0px; font-weight: 300;padding-top:1px;padding-bottom:1px;" v-else>--</h3>
              </div>
              </div>
            </v-col>
             <v-col v-if="companyData && companyData.company_dashboard_dict && companyData.company_dashboard_dict.chat_response_stats">
              <div style="padding: 24px;border: 1px solid #e6e6e6; border-radius: 24px;"> 
              <p class="cardTitle mb-0">Inprogress</p>
               <div class="mt-6">
              <h3 class="mainStats" v-if="companyData.company_dashboard_dict.chat_response_stats.inProgress">{{companyData.company_dashboard_dict.chat_response_stats.inProgress}}</h3>
              <h3 style="color: rgb(77, 87, 93); font-size: 25px; margin: 5px 0px 0px; font-weight: 300;padding-top:1px;padding-bottom:1px;" v-else>--</h3>
               </div>
               </div>
            </v-col>
            <v-col>
              <div style="padding: 24px;border: 1px solid #e6e6e6; border-radius: 24px;">
              <p class="cardTitle mb-0">Completed</p>
              <div class="mt-6">
              <h3 class="mainStats" v-if="companyData.company_dashboard_dict.chat_response_stats.completed">{{companyData.company_dashboard_dict.chat_response_stats.completed}}</h3>
              <h3 style="color: rgb(77, 87, 93); font-size: 25px; margin: 5px 0px 0px; font-weight: 300;padding-top:1px;padding-bottom:1px;" v-else>--</h3>
              </div>
              </div>
            </v-col>
          </v-row>
        </div>
        <div style="background: white; border-radius:24px; padding: 24px;text-align:left;margin-top:24px;">
          <h3 class="my-2 text-left">User details</h3>
          <v-row style="width:100%;align-items: center; margin:0; border-radius:10px;text-align:left;">
            <v-col cols="3" style="padding: 31px;" v-if="companyData && companyData.company_dashboard_dict && companyData.company_dashboard_dict.chat_response_stats">
            
            <div style="padding: 24px;border: 1px solid #e6e6e6; border-radius: 24px;">
              <p class="cardTitle mb-0">Total booked users</p>
            <div class="mt-6">
            <h3 class="mainStats" style="" v-if="companyData && companyData.company_details.user_booked">{{companyData.company_details.user_booked}}</h3>
            <h3 style="display:inline-block; width:200px;color: rgb(77, 87, 93); font-size: 25px;padding-top:1px;padding-bottom:1px; margin: 5px 0px 0px; font-weight: 300;" v-else>--</h3>
            </div>
            </div>
          </v-col>
            <v-col cols="3" v-for="(u, i) in companyData.company_details.users_status" :key="i">
              <div style="padding: 24px;border: 1px solid #e6e6e6; border-radius: 24px;">
              <p class="cardTitle mb-0 text-capitalize">{{u.status}}</p>
              <div class="mt-6">
            <h3 class="mainStats" style="" v-if="u.count">{{u.count}}</h3>
            <h3 style="display:inline-block; width:200px;color: rgb(77, 87, 93); font-size: 25px;padding-top:1px;padding-bottom:1px; margin: 5px 0px 0px; font-weight: 300;" v-else>--</h3>
            </div>
            </div>
            </v-col>
          </v-row>
        </div>
      </v-card>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import moment from 'moment';
import infiniteScroll from 'vue-infinite-scroll';
import { mapState } from 'vuex';

export default {
  name: 'companyList',

  components: {
    axios,
    infiniteScroll
  },

  data: () => ({
    moment: moment,
    data: [],
    companyData: null,
    loading: false,
    avatarList: [],
    pagination: {
      rowsPerPage: 10,
      page: 1,
      length: 1
    },
    busy: false,
    searchCompany: '',
    filter_type: null,
    emailTemplate: null,
    companyAccountData: null,
  }),
  watch : {
  },
  computed: {
    ...mapState({
      snackbar: state => state.snackbar,
      user: state => state.user
    })
  },
  mounted () {
    this.getCompanyDetails(this.$route.query.cid);
  },
  methods: {
    getCompanyDetails (id) {
        this.isLoadingData = true;
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        axios.get(`${process.env.VUE_APP_API_URL}company/profile/${id}?fields=company_name,brand_name,spoc_name,allow_stage_edit,spoc_email,spoc_phone,country,company_address,company_logo,createdBy,company_type,chat_cobranding_enabled,createdAt,is_active,employee_strength,chat_cobranding_enabled,tags,facebook_link,linkedin_link,glassdoor_link,jobStreet_link,activatedAt,user_booked,users_status,companies_avatar,company_avatar,total_arr,renewal_date,is_visible_in_admin_panel,employee_data_source&company_dashboard_details=engagement_score,disengaged_employees_stats,fence_sitters_employees_stats,user_participation_stats,company_employee_reach_stats`, {
          withCredentials: true
        }).then((response) => {
          if (response && response.data) {
            this.companyData = response.data;
            this.isLoadingData = false;
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.config.savingStage = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch details, Please try again later!'
            });
          }
        });
      },
    editCompany (data) {
      this.$router.push(`/company-details?cid=${data.id}&editview=true`);
    },
  },
}
</script>
<style lang="scss" >
.heading {
  font-size: 12px;
  padding-top:10px;
}
.dashboardCount {
  font-size: 70px;
  padding:10%;
}
.mainBox {
    background-color: white;
    border-radius: 6px;
    box-shadow: 0 4px 16px 11px rgb(0 0 0 / 6%), 0 4px 8px rgb(0 0 0 / 10%) !important;
    height: 16rem;
    transition: 0.5s;
    -webkit-transition: 0.5s;
    text-align: center;
}
.v-btn--active {
    background-color: #050550 !important;
  }
.disabledView {
  .v-btn--active {
    background-color: #858585 !important;
  }
}
#chartdiv1 {
  height: 400px;
  width:100%;
}

.primary--text {
  color: #050550 !important;
}
#chartdiv {
  width: 100%;
  height: 210px;
  
}
.headingprofile {
  text-align: left;
  h2 {
    color: #263238;
    font-weight: 500;
    line-height: 1.1;
    font-size: 20px;
    margin: 0 0 6px;
    width: 100%;
  }
}
.box-detail {
  background-color: #f6f6f8;
  padding-left:10px;
  border-radius:6px;
}
</style>
